/* eslint-disable max-len */
import 'react';

const ReadNumberSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M8 15c-.617-.667-1.603-1-2.956-1H2a1 1 0 01-1-1V3a1 1 0 011-1h3a3 3 0 013 3"
                stroke="#C7CDD9"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M8 9.5V5a3 3 0 013-3h3a1 1 0 011 1v10a1 1 0 01-1 1h-2.938C9.7 14 8.68 14.333 8 15"
                stroke="#C7CDD9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
export default ReadNumberSvg;
